/* ---------------------------------------------------------------------------
   <kmb-swiper> — waagerechter Produktstreifen mit Pfeilen
   ---------------------------------------------------------------------------
   Benutzt von snippets/complementary-products.liquid ("Perfekte Kombination zu").

   🔴 Warum ein Custom Element und kein Inline-<script> im Snippet:
   Die Empfehlungen kommen nicht mit der Seite, sondern werden von Prestiges
   <product-recommendations> nachgeladen (assets/theme.js, loadRecommendations_fn).
   Das parst die Antwort mit DOMParser und setzt sie per replaceChildren ein —
   und <script>-Elemente aus einem DOMParser-Dokument fuehrt der Browser
   grundsaetzlich nicht aus. Ein Inline-Skript im Snippet waere toter Code.

   Ein Custom Element hat das Problem nicht: connectedCallback feuert, sobald der
   Knoten im Dokument landet, egal wie er dorthin kam.

   Markup, das erwartet wird:
     <kmb-swiper>
       <div data-spur>          <- der scrollende Streifen
         <div>...Karte...</div>
       </div>
       <button data-zurueck>    <- optional
       <button data-vor>        <- optional
     </kmb-swiper>

   Die Pfeile duerfen ausserhalb der Spur liegen (sie sitzen in der Kopfzeile) —
   gesucht wird im ganzen Element.
--------------------------------------------------------------------------- */
(function () {
  if (window.customElements.get('kmb-swiper')) return;

  class KmbSwiper extends HTMLElement {
    connectedCallback() {
      if (this._fertig) return;
      this._fertig = true;

      this.spur = this.querySelector('[data-spur]');
      if (!this.spur) return;
      this.zurueck = this.querySelector('[data-zurueck]');
      this.vor = this.querySelector('[data-vor]');
      this.leiste = this.querySelector('[data-leiste]');
      this.daumen = this.leiste ? this.leiste.firstElementChild : null;

      this._pruefen = this._pruefen.bind(this);

      if (this.zurueck) this.zurueck.addEventListener('click', () => this._rollen(-1));
      if (this.vor) this.vor.addEventListener('click', () => this._rollen(1));
      this.spur.addEventListener('scroll', this._pruefen, { passive: true });
      window.addEventListener('resize', this._pruefen);

      // Bilder sind beim Einsetzen meist noch nicht geladen; erst danach steht die
      // endgueltige Breite fest und der "weiter"-Pfeil kann korrekt abgeblendet
      // werden. ResizeObserver statt load-Handler auf jedem Bild.
      if (typeof ResizeObserver === 'function') {
        this._beobachter = new ResizeObserver(this._pruefen);
        this._beobachter.observe(this.spur);
      }
      this._pruefen();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._pruefen);
      if (this._beobachter) this._beobachter.disconnect();
    }

    // Eine Kartenbreite plus Abstand — damit landet die naechste Karte am linken
    // Rand, statt irgendwo mittendrin zu stehen.
    _schritt() {
      const karte = this.spur.firstElementChild;
      if (!karte) return this.spur.clientWidth;
      const stil = getComputedStyle(this.spur);
      const abstand = parseFloat(stil.columnGap) || parseFloat(stil.gap) || 0;
      return karte.getBoundingClientRect().width + abstand;
    }

    _rollen(richtung) {
      this.spur.scrollBy({ left: richtung * this._schritt(), behavior: 'smooth' });
    }

    _pruefen() {
      const links = this.spur.scrollLeft;
      const maximal = this.spur.scrollWidth - this.spur.clientWidth;

      // 🔴 2 px Toleranz. Bei Bruchteil-Pixeln (Prozentbreiten, Zoomstufen) wird
      // `maximal` sonst nie ganz erreicht und der Pfeil bleibt fuer immer aktiv.
      if (this.zurueck) this.zurueck.disabled = links <= 2;
      if (this.vor) this.vor.disabled = links >= maximal - 2;

      // Scroll-Anzeige. Der Daumen ist so breit wie der sichtbare Anteil des
      // Streifens und wandert ueber die restliche Strecke — damit sagt der Balken
      // zwei Dinge auf einmal: wie viel es insgesamt gibt und wo man steht.
      if (!this.leiste || !this.daumen) return;
      if (maximal <= 2) {
        // Nichts zu scrollen: ein Balken ueber die volle Breite waere eine Luege.
        this.leiste.hidden = true;
        return;
      }
      this.leiste.hidden = false;
      const anteil = this.spur.clientWidth / this.spur.scrollWidth;
      const fortschritt = Math.min(1, Math.max(0, links / maximal));
      this.daumen.style.width = (anteil * 100).toFixed(2) + '%';
      this.daumen.style.left = ((1 - anteil) * fortschritt * 100).toFixed(2) + '%';
    }
  }

  window.customElements.define('kmb-swiper', KmbSwiper);
})();
